(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ertelt-legal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const openFromHash = () => {
      const id = decodeURIComponent(location.hash.slice(1));
      if (!id) return;
      const item = document.getElementById(id);
      if (!(item instanceof HTMLDetailsElement)) return;
      item.open = true;
      item.scrollIntoView({ block: 'start' });
    };

    // Keep the address bar in sync so a row can be linked to directly.
    document.addEventListener(
      'toggle',
      (event) => {
        const item = event.target;
        if (!(item instanceof HTMLDetailsElement) || !item.classList.contains('ertelt-legal__item')) return;
        if (item.open) history.replaceState(null, '', `#${item.id}`);
      },
      true
    );

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-ertelt-cookie-settings]');
      if (!button) return;
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
        return;
      }
      // The banner script only loads where Shopify's cookie banner is enabled for the visitor's region.
      const fallback = button.nextElementSibling;
      if (fallback) fallback.hidden = false;
    });

    window.addEventListener('hashchange', openFromHash);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openFromHash);
    } else {
      openFromHash();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ertelt-size-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.ertelt-size');
    if (!root) return;
    const input = root.querySelector('[data-size-input]');
    const result = root.querySelector('[data-size-result]');
    const rows = [...root.querySelectorAll('tbody tr')];
    const idle = result.innerHTML;

    const update = () => {
      rows.forEach((row) => row.classList.remove('is-active'));
      const raw = parseFloat(String(input.value).replace(',', '.'));
      if (!Number.isFinite(raw) || raw <= 0) { result.innerHTML = idle; return; }
      const mode = root.querySelector('input[name="ertelt-size-mode"]:checked').value;
      const circumference = mode === 'diameter' ? raw * Math.PI : raw;
      if (circumference < 49.5 || circumference > 74.5) {
        result.innerHTML = '<span class="ertelt-size__result-idle">that is outside EU 50–74, but write me and I can cast it anyway</span>';
        return;
      }
      // Clearly between two sizes: take the larger, as the wide bands sit tighter.
      const between = Math.abs(circumference - Math.round(circumference)) >= 0.25 && Math.floor(circumference) >= 50 && Math.ceil(circumference) <= 74;
      const eu = between ? Math.ceil(circumference) : Math.round(circumference);
      const row = rows.find((r) => Number(r.dataset.eu) === Math.min(74, Math.max(50, eu)));
      row.classList.add('is-active');
      result.innerHTML =
        '<span class="ertelt-size__result-eu">EU ' + row.dataset.eu + '</span>' +
        '<span class="ertelt-size__result-rest">US ' + row.dataset.us + ' · UK ' + row.dataset.uk + '</span>' +
        (between ? '<span class="ertelt-size__result-idle">between ' + (row.dataset.eu - 1) + ' and ' + row.dataset.eu + ', and the larger fits these wide bands</span>' : '');
    };

    input.addEventListener('input', update);
    root.querySelectorAll('input[name="ertelt-size-mode"]').forEach((r) => r.addEventListener('change', update));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
